import { h } from 'hyperapp';
import cc from 'classcat';
import './index.less';
export default (({
  show
}) => h("div", {
  class: cc(['mc-loaded', {
    'mdui-hidden': !show
  }]),
  key: "mc-loaded"
}));